import { render, staticRenderFns } from "./DialogCosttype.vue?vue&type=template&id=c37f6b40"
import script from "./DialogCosttype.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogCosttype.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports